import { LegalLayout, LegalSection, ContactEmail } from "../../components/LegalLayout";

export default function AntiSpamPolicy() {
  return (
    <LegalLayout
      title="Anti-Spam Policy | EnquiryOps"
      description="EnquiryOps anti-spam policy: opt-in only marketing email and WhatsApp messages, one-to-one business correspondence, and how to report abuse."
      heading="Anti-Spam Policy"
      updated="19 July 2026"
    >
      <LegalSection title="Our Commitment">
        <p>
          EnquiryOps does not send unsolicited bulk email or messages, and we prohibit the use of our platform,
          our domain, and our services for spam of any kind. Every message sent through EnquiryOps must comply
          with this policy and with applicable law, including Singapore's Spam Control Act.
        </p>
      </LegalSection>

      <LegalSection title="Bulk and Marketing Messages">
        <p>
          Bulk and marketing messages, whether by email, WhatsApp, or SMS, are sent only to recipients who have
          opted in to receive them. We do not use purchased, rented, or harvested contact lists, and we do not
          permit our customers to do so through EnquiryOps.
        </p>
        <p>
          Every marketing message includes a clear and working way to unsubscribe or opt out, and opt-out
          requests are honoured promptly.
        </p>
      </LegalSection>

      <LegalSection title="Individual Business Correspondence">
        <p>
          One-to-one business messages, such as replies to a parent's enquiry or follow-ups about a booked
          trial, are clearly identified with a named sender and always include a working opt-out. Recipients can
          stop receiving these messages at any time by replying or by using the opt-out provided.
        </p>
      </LegalSection>

      <LegalSection title="Third-Party Use of Our Domain">
        <p>
          Third parties are prohibited from using enquiryops.com, or any address on our domain, to promote any
          product or service via unsolicited email or messaging. Any such use is unauthorised and will be
          pursued to the fullest extent available to us.
        </p>
      </LegalSection>

      <LegalSection title="Reporting Abuse">
        <p>
          If you believe you have received spam sent through EnquiryOps, or that our domain is being misused,
          report it to <ContactEmail email="unsubscribe@getenquiryops.com" />. Please include the message in question and any relevant headers or
          screenshots. Reports are reviewed and responded to within 2 business days.
        </p>
      </LegalSection>

      <LegalSection title="Enforcement">
        <p>
          Violations of this policy result in immediate suspension of the offending account or sender. Repeat or
          serious violations result in permanent termination and, where appropriate, referral to the relevant
          authorities.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
